import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { NewPracticePage } from '@/pages/NewPractice'

export const Route = createFileRoute('/_authenticated/practices_/create')({
  component: NewCustomerGuard,
})

function NewCustomerGuard() {
  return (
    <PermissionRouteGuard resource="customer_profiles" action="create">
      <NewPracticePage />
    </PermissionRouteGuard>
  )
}
